import { atom } from 'jotai';
import { calculateBMI } from '@/shared/helpers/calculateBMI';
import { formatNumber } from '@/shared/helpers/formatNumber';
import { fetchSundVaegtProgramQueryAtom } from './fetchSundVaegtProgramQueryAtom';
import {
    WeightAndBmi,
    WeightProgress,
} from '@/features/programs/widgets/sundvaegt/model/types';

export const weightLossProgressAtom = atom<WeightProgress | null>((get) => {
    const program = get(fetchSundVaegtProgramQueryAtom).data;
    if (!program || program.WeightLogs.length === 0) return null;

    const sortedLogs = [...program.WeightLogs].sort(
        (a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime(),
    );

    const firstLog = sortedLogs[0];
    const initialBmi = calculateBMI(
        Number(program.HeightCm),
        Number(firstLog.WeightKg),
    );

    let desired: WeightAndBmi | null = null;
    let progress = null;

    let showProgressLabel = false;
    let formattedTotalWeightLoss = null;
    let formattedWeightLossGoal = null;

    if (program.DesiredWeightKg > 0) {
        const desiredBmi = calculateBMI(
            Number(program.HeightCm),
            Number(program.DesiredWeightKg),
        );
        desired = {
            weightKg: program.DesiredWeightKg,
            bmi: desiredBmi,
        };

        if (sortedLogs.length > 1) {
            const lastWeight = sortedLogs[sortedLogs.length - 1].WeightKg;
            const goalInterval = firstLog.WeightKg - program.DesiredWeightKg;
            const currentProgressInterval = firstLog.WeightKg - lastWeight;

            if (goalInterval > 0 && currentProgressInterval > 0) {
                progress = Math.round(
                    (currentProgressInterval / goalInterval) * 100,
                );

                showProgressLabel = true;
                formattedTotalWeightLoss = `${formatNumber(currentProgressInterval)} kg`;
                formattedWeightLossGoal = `${formatNumber(goalInterval)} kg`;
            }

            if (currentProgressInterval < 0) {
                progress = 0;
            }
        }
    }

    return {
        initial: {
            weightKg: firstLog.WeightKg,
            bmi: initialBmi,
        },
        heightCm: program.HeightCm,
        desired,
        weightGoalEntered: desired && desired.weightKg && desired.weightKg > 0,
        progress,
        progressNormalized: progress / 100,
        showProgressLabel,
        formattedTotalWeightLoss,
        formattedWeightLossGoal,
    };
});
